export const get_layer_page_category = () => {
    const element = window?.document?.querySelector('[data-gtm]')
    if (element) {
        const value = element?.getAttribute('data-gtm')
        switch (value) {
            case 'product-list-page':
                return 'category'
            case 'product-details-page':
                return 'detail'
            case 'psp-page':
                return 'category'
            case 'checkout-page':
                return 'checkout'
            case 'guest-checkout-page':
                return 'checkout'
            case 'cart-page':
                return 'checkout'
            case 'cart-page-skeleton':
                return 'skeleton-cart'
            case 'confirmation-page':
                return 'checkout'
            case 'checkout-error-page':
                return 'checkout'
            case 'internal-search-result-page':
                return 'search'
            case 'contact-us-page':
                return 'customer_service'
            case 'faq-page':
                return 'customer_service'
            case 'homepage':
                return 'home'
            case 'service-locator-page':
                return 'service_locator'
            case 'login-page':
                return 'reserved_area'
            case 'registration-page':
                return 'reserved_area'
            case 'account-detail-page':
                return 'reserved_area'
            default:
                return ''
        }
    }
    return
}

export const get_layer_page_subcategory = () => {
    const element = window?.document?.querySelector('[data-gtm]')
    if (element) {
        const value = element?.getAttribute('data-gtm')
        switch (value) {
            case 'product-list-page':
                return 'micro'
            case 'product-details-page':
                return ''
            case 'psp-page':
                return 'macro'
            case 'checkout-page':
                return 'checkout'
            case 'guest-checkout-page':
                return 'checkout'
            case 'cart-page':
                return 'cart'
            case 'confirmation-page':
                return 'purchase'
            case 'checkout-error-page':
                return 'checkout_failed'
            case 'internal-search-result-page':
                return ''
            case 'contact-us-page':
                return 'other'
            case 'faq-page':
                return 'faq'
            case 'homepage':
                return ''
            case 'service-locator-page':
                return ''
            case 'login-page':
                return 'login_form'
            case 'registration-page':
                return 'registration_form'
            case 'account-detail-page':
                return 'reserved'
            default:
                return ''
        }
    }
    return
}

export const retrieve_status_code_gtm = () => {
    const statusElement = document?.querySelector('[data-status-code]')
    if (statusElement) return statusElement?.getAttribute('data-status-code')
    else return 200
}

export const page_view = (data) => ({
    event: 'page_view',
    page_path: data.page_path || '',
    page_title: document.title,
    page_location: window.location.href,
})

export const virtual_page_view = (data) => ({
    event: data.event || 'virtualPageview',
    virtualUrl: data.virtualUrl || '',
    userId: data?.c_gigyaId || '',
    emailMD5: data.emailMD5 || '',
    emailSHA256: data.emailSHA256 || '',
    email: data.email || '',
    name: data.name || '',
    surname: data.surname || '',
    device: data.device || '',
    eCommerceSite: data.eCommerceSite || true,
    pageCountry: data.pageCountry || 'gb',
    pageLanguage: data.pageLanguage || 'en',
    pageCategory: data.pageCategory || '',
    pageSubCategory: data.pageSubCategory || '',
    statusCode: data.statusCode || 200,
})

export const basic_gtm_event = (data) => ({
    event: data.event || null,
    eventCategory: data.eventCategory || null,
    eventAction: data.eventAction || null,
    eventLabel: data.eventLabel || null,
    ...(data.method && {method: data.method}),
    ...(data.resultsAmount !== undefined &&
        data.resultsAmount !== null && {resultsAmount: data.resultsAmount}), // Add also 0 value
    ...(data.eventDetail && {eventDetail: data.eventDetail}),
    ...(data.userId && {userId: data.userId}),
    ...(data.email && {email: data.email}),
    ...(data.emailSHA256 && {emailSHA256: data.emailSHA256}),
})

export const item_gtm_event = (data) => ({
    event: data.event || null,
    ecommerce: {
        ...(data.item_list_name && {item_list_name: data.item_list_name}),
        ...(data.currency && {currency: data.currency}),
        ...(data.bundle && {bundle: data.bundle}),
        ...(data.bundle_id && {bundle_id: data.bundle_id}),
        ...(data.value && {value: data.value}),
        items: data.items || null,
    },
})

export const polish_ecommerce_gtm_event = () => ({
    ecommerce: null,
})

export const simple_gtm_event = (data) => ({
    event: data.event || null,
})

export const get_reevoo_rating = () => {
    const reevoo = window?.document?.querySelector('reevoo-badge')
    if (reevoo) {
        const reevooIframe = reevoo?.querySelector('iframe')
        const reevooDoc = reevooIframe?.contentWindow?.document
        const reviewsBody = reevooDoc?.querySelector('body')
        const innerDiv = reviewsBody?.querySelector('div[data-feefo-action="reviews"]')
        const reevooRatingDiv = innerDiv?.querySelector('reevoo-stars')
        const ratingPoints = reevooRatingDiv?.getAttribute('data-score')
        if (ratingPoints) return ratingPoints
        else return '0.0'
    } else return null
}

export const get_bv_rating = () => {
    const bazaarVoiceRating = window?.document?.querySelector('.bv_text')
    if (bazaarVoiceRating) return bazaarVoiceRating?.textContent
    else return
}

export const get_reevoo_multiple = () => {
    const reevoo = window?.document?.querySelectorAll('reevoo-badge')
    if (reevoo) {
        //?map through all reevoo elements and get the rating points
        const reevooRatingPoints = Array.from(reevoo).map((item) => {
            const reevooIframe = item?.querySelector('iframe')
            const reevooDoc = reevooIframe?.contentWindow?.document
            const reviewsBody = reevooDoc?.querySelector('body')
            const innerDiv = reviewsBody?.querySelector('div[data-feefo-action="reviews"]')
            const reevooRatingDiv = innerDiv?.querySelector('reevoo-stars')
            const ratingPoints = reevooRatingDiv?.getAttribute('data-score')
            if (ratingPoints) return ratingPoints
            else return '0.0'
        })
        return reevooRatingPoints
    } else return null
}

export const get_bv_multiple = () => {
    const bazaarVoiceRating = window?.document?.querySelectorAll('.bv_text')
    if (bazaarVoiceRating) {
        const bazaarVoiceRatingPoints = Array.from(bazaarVoiceRating).map(
            (item) => item?.textContent,
        )
        return bazaarVoiceRatingPoints
    }
}
